import React, {useEffect, useState} from "react";
import { Paper, Divider, Card } from "@mui/material";
import api from "../../API/api";


export default function AllSubjects() {

    const [courses, setCourses] = useState();

    const getAllCourse=()=>{
        api.getAllCourse().then((res)=>{
            // console.log("res", res);
            setCourses(res.data.courses);
        })
        .catch((err)=>{
            // console.log(err);
        })
    }

    useEffect(()=>{
        getAllCourse();
    },[])



  return (
    <div className="mt-3">
    <Paper>
      <div>
        <div className="text-center py-5">
          <h2>Courses</h2>
          {/* <div>All subject</div> */}
          <div className="">
            {courses && courses.map((c)=>(
            <button className="btn btn-primary m-1">{c.courseName}</button>
            ))}
          </div>
        </div>
      </div>
    </Paper>
    </div>
  );
}
